jQuery(function ($) {

  function updateToolbar(slick, currentSlide) {
    const $slider  = slick.$slider;
    const $toolbar = $slider.next('.slider-toolbar');
    if (!$toolbar.length) return;

    const totalSlides = slick.slideCount || 1;
    const slidesToShow = Math.max(1, Number(slick.options.slidesToShow) || 1);
    const current = (typeof currentSlide === 'number')
      ? currentSlide
      : (slick.currentSlide || 0);

    const displayIndex = Math.min(current + 1, totalSlides);
    $toolbar.find('.pagingInfo').text(displayIndex + '/' + totalSlides);

    const maxIndex = Math.max(0, Math.ceil(totalSlides - slidesToShow));

    const isPrevDisabled = current <= 0;
    const isNextDisabled = current >= maxIndex;

    $toolbar.find('.slick-prev-btn')
      .prop('disabled', isPrevDisabled)
      .toggleClass('is-disabled', isPrevDisabled);

    $toolbar.find('.slick-next-btn')
      .prop('disabled', isNextDisabled)
      .toggleClass('is-disabled', isNextDisabled);

    const $track = $toolbar.find('.scroll-track');
    const $thumb = $toolbar.find('.scroll-thumb');

    if (!$track.length || !$thumb.length) return;

    const trackWidth = $track.width();
    const safeTotal = Math.max(totalSlides, slidesToShow);

    const thumbWidth = trackWidth * (slidesToShow / safeTotal);
    $thumb.width(thumbWidth);

    const maxThumbMove = Math.max(0, trackWidth - thumbWidth);

    let left = maxIndex > 0
      ? (current / maxIndex) * maxThumbMove
      : 0;

    left = Math.max(0, Math.min(maxThumbMove, left));

    if (document.documentElement.dir === 'rtl') {
      $thumb.css({ right: left + 'px', left: '' });
    } else {
      $thumb.css({ left: left + 'px', right: '' });
    }
  }

  // ✅ IMAGE LOADING OPTIMIZATION
  function updateImageLoading(slick) {
    const slidesToShow = Math.ceil(slick.options.slidesToShow || 1);
    const current = slick.currentSlide || 0;

    $(slick.$slides).each(function (index) {
      const $img = $(this).find('img');
      if (!$img.length) return;

      if (index >= current && index < current + slidesToShow) {
        $img.attr('loading', 'eager');
        $img.attr('fetchpriority', 'high');
      } else {
        $img.attr('loading', 'lazy');
        $img.removeAttr('fetchpriority');
      }
    });
  }

  function manageSlideFocus(slick) {
    const $slides = $(slick.$slides);

    $slides.each(function () {
      const $slide = $(this);
      const isHidden = $slide.attr('aria-hidden') === 'true';

      const $focusables = $slide.find(
        'a, button, input, select, textarea, [tabindex]'
      );

      if (isHidden) {
        $focusables.attr('tabindex', '-1');
      } else {
        $focusables.removeAttr('tabindex');
      }
    });
  }

  function initPanelSlider($panel) {
    const $slider = $panel.find('.products-slick').first();
    if (!$slider.length) return;

    const $toolbar = $slider.next('.slider-toolbar');
    if (!$toolbar.length) return;

    const $prevBtn = $toolbar.find('.slick-prev-btn');
    const $nextBtn = $toolbar.find('.slick-next-btn');
    const $track   = $toolbar.find('.scroll-track');
    const $thumb   = $toolbar.find('.scroll-thumb');

    if ($slider.hasClass('slick-initialized')) {
      const slick = $slider.slick('getSlick');
      updateToolbar(slick, slick.currentSlide || 0);
      manageSlideFocus(slick);
      updateImageLoading(slick); // ✅
      return;
    }

    // Events
    $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
      updateToolbar(slick, currentSlide);
      manageSlideFocus(slick);
      updateImageLoading(slick); // ✅
    });

    $slider.on('beforeChange', function (event, slick) {
      manageSlideFocus(slick);
      updateImageLoading(slick); // ✅
    });

    // Init slick
    $slider.slick({
      rtl: document.documentElement.dir === 'rtl',
      slidesToShow: 4.5,
      slidesToScroll: 3,
      infinite: false,
      arrows: false,
      dots: false,
      adaptiveHeight: false,
      speed: 400,
      swipeToSlide: true,
      accessibility: true,
      lazyLoad: 'ondemand', // 👈 IMPORTANT (works with our logic)
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 4.5 } },
        { breakpoint: 990,  settings: { slidesToShow: 3.5 } },
        { breakpoint: 750,  settings: { slidesToShow: 2.8 } },
        { breakpoint: 480,  settings: { slidesToShow: 1.8 } }
      ]
    });

    $prevBtn.on('click', function (e) {
      e.preventDefault();
      $slider.slick('slickPrev');
    });

    $nextBtn.on('click', function (e) {
      e.preventDefault();
      $slider.slick('slickNext');
    });

    // Drag scrollbar
    let isDragging = false;
    let startX = 0;
    let startLeft = 0;
    let animationFrame = null;

    function goToPercent(percent) {
      const slick = $slider.slick('getSlick');
      const totalSlides = slick.slideCount;
      const slidesToShow = slick.options.slidesToShow;
      const maxIndex = Math.max(0, Math.ceil(totalSlides - slidesToShow));

      const targetIndex = Math.round(percent * maxIndex);
      $slider.slick('slickGoTo', targetIndex, false);
    }

    function updateFromPosition(newLeft) {
      const trackWidth = $track.width();
      const thumbWidth = $thumb.width();
      const maxMove = Math.max(0, trackWidth - thumbWidth);

      newLeft = Math.max(0, Math.min(maxMove, newLeft));
      const percent = maxMove > 0 ? newLeft / maxMove : 0;

      goToPercent(percent);
    }

    $thumb.on('mousedown touchstart', function (e) {
      isDragging = true;
      $thumb.css('transition', 'none');

      startX = e.type === 'touchstart'
        ? e.originalEvent.touches[0].clientX
        : e.clientX;

      startLeft = document.documentElement.dir === 'rtl'
        ? parseFloat($thumb.css('right')) || 0
        : parseFloat($thumb.css('left')) || 0;

      e.preventDefault();
    });

    $(document).on('mousemove touchmove', function (e) {
      if (!isDragging) return;

      const clientX = e.type === 'touchmove'
        ? e.originalEvent.touches[0].clientX
        : e.clientX;

      const delta = document.documentElement.dir === 'rtl'
        ? startX - clientX
        : clientX - startX;

      const newLeft = startLeft + delta;

      if (animationFrame) cancelAnimationFrame(animationFrame);

      animationFrame = requestAnimationFrame(function () {
        updateFromPosition(newLeft);
      });
    });

    $(document).on('mouseup touchend', function () {
      if (!isDragging) return;
      isDragging = false;

      $thumb.css(
        'transition',
        document.documentElement.dir === 'rtl'
          ? 'right 0.25s ease'
          : 'left 0.25s ease'
      );
    });

    $track.on('click', function (e) {
      if ($(e.target).is('.scroll-thumb')) return;

      const isRTL = document.documentElement.dir === 'rtl';
      const trackOffset = $track.offset();
      const trackWidth = $track.width();

      const clickX = isRTL
        ? (trackOffset.left + trackWidth) - e.clientX
        : e.clientX - trackOffset.left;

      const percent = Math.max(0, Math.min(1, clickX / trackWidth));
      goToPercent(percent);
    });

    // Initial sync
    setTimeout(function () {
      const slick = $slider.slick('getSlick');
      updateToolbar(slick, slick.currentSlide || 0);
      manageSlideFocus(slick);
      updateImageLoading(slick); // ✅
    }, 0);

    $slider.on('breakpoint', function (event, slick) {
      setTimeout(function () {
        updateToolbar(slick, slick.currentSlide || 0);
        manageSlideFocus(slick);
        updateImageLoading(slick); // ✅
      }, 0);
    });
  }

  $('.tab-data:not([hidden])').each(function () {
    initPanelSlider($(this));
  });

  $(document).on('click', ".tab-button[role='tab']", function () {
    const panelId = $(this).attr('aria-controls');
    const $panel = panelId ? $('#' + panelId) : $();

    setTimeout(function () {
      if (!$panel.length) return;

      initPanelSlider($panel);

      const $slider = $panel.find('.products-slick').first();
      if ($slider.length && $slider.hasClass('slick-initialized')) {
        $slider.slick('slickGoTo', 0, true);

        const slick = $slider.slick('getSlick');
        updateToolbar(slick, 0);
        manageSlideFocus(slick);
        updateImageLoading(slick); // ✅

        $slider.slick('setPosition');
      }
    }, 60);
  });

  document.addEventListener('shopify:section:load', function (event) {
    const $scope = $(event.target);
    $scope.find('.tab-data:not([hidden])').each(function () {
      initPanelSlider($(this));
    });
  });

});


// ===== VIEW ALL LINK SYNC =====
(function () {
  function updateViewAllLink(sectionEl) {
    if (!sectionEl) return;

    const viewAll = sectionEl.querySelector('.view-all-btn');
    if (!viewAll) return;

    const activePanel = sectionEl.querySelector('.tab-data:not([hidden])');
    if (!activePanel) return;

    const url = activePanel.getAttribute('data-collection-url') || '#';
    viewAll.setAttribute('href', url);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.section-carousel-products').forEach((sectionEl) => {
      updateViewAllLink(sectionEl);

      sectionEl.addEventListener('click', function (e) {
        const btn = e.target.closest('.tab-button');
        if (!btn) return;
        requestAnimationFrame(() => updateViewAllLink(sectionEl));
      });

      sectionEl.addEventListener('keyup', function (e) {
        const btn = e.target.closest('.tab-button');
        if (!btn) return;
        if (e.key !== 'Enter' && e.key !== ' ') return;
        requestAnimationFrame(() => updateViewAllLink(sectionEl));
      });
    });
  });
})();